import { ProgramScopeType, ProgramScopedContentRow } from '../types/domain';
import {
  filterProgramScopedContentRowsByTermNumber,
  loadProgramScopedContentRowsCache,
} from '../utils/programScopedContentRowsCache';
import { loadAnnualProgressScopedTermCache } from '../utils/annualProgressScopedTermCache';

/**
 * LS에 저장된 행이 현재 스코프와 일치하는지.
 * - 다른 scope_key가 하나라도 있으면 거부
 * - scope_key가 비어 있는 행만 있으면(레거시) 통과
 */
export function scopedContentLsRowsMatchScopeKey(
  rows: ProgramScopedContentRow[],
  expectedScopeKey: string
): boolean {
  const ex = expectedScopeKey.trim();
  if (!ex || !rows.length) return true;
  let sawExpected = false;
  for (const r of rows) {
    const sk = (r.scope_key ?? '').trim();
    if (!sk) continue;
    if (sk !== ex) return false;
    sawExpected = true;
  }
  if (sawExpected) return true;
  return rows.every((r) => !(r.scope_key ?? '').trim());
}

export function readValidScopedContentRowsFromLocalCache(
  workspaceId: string,
  academicYear: number,
  termNumber: 1 | 2,
  gradeId: string,
  scopeType: ProgramScopeType,
  scopeKey: string
): { found: boolean; rows: ProgramScopedContentRow[] } {
  const snap = loadProgramScopedContentRowsCache(
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    scopeType,
    scopeKey
  );
  if (!snap.found) return { found: false, rows: [] };
  const forTerm = filterProgramScopedContentRowsByTermNumber(snap.rows, termNumber);
  if (!scopedContentLsRowsMatchScopeKey(forTerm, scopeKey)) return { found: false, rows: [] };
  return { found: true, rows: forTerm };
}

export function sliceScopedRowsFromGradeTermLocalCache(
  workspaceId: string,
  academicYear: number,
  termNumber: 1 | 2,
  gradeId: string,
  scopeType: ProgramScopeType,
  scopeKey: string
): ProgramScopedContentRow[] {
  const term = loadAnnualProgressScopedTermCache(workspaceId, academicYear, termNumber, gradeId);
  if (!term.found || !term.rows.length) return [];
  const ex = scopeKey.trim();
  return filterProgramScopedContentRowsByTermNumber(
    term.rows.filter((r) => r.scope_type === scopeType && (r.scope_key ?? '').trim() === ex),
    termNumber
  );
}
